// src/App.jsx
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import HomePage from "./pages/Homepage";
import AboutUsPage from "./pages/AboutUsPage";
import OurProductsPage from "./pages/OurProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import InfraDetailPage from "./pages/InfraDetailPage";
import DownloadsPage from "./pages/DownloadsPage";
import CaseStudyDetailPage from "./pages/CaseStudyDetailPage";
import ContactUsPage from "./pages/ContactUsPage";

import { useLocale } from "./contexts/LocaleContext";
import { useApiLoading } from "./contexts/LoadingContext";
import { setGlobalLoadingCallbacks } from "./api/axiosInstance";
import LoadingBackdrop from "./components/common/LoadingBackdrop";

function App() {
  const { footerText, isLoadingSharedData } = useLocale();
  const { isApiLoading, _showApiLoadingInternal, _hideApiLoadingInternal } =
    useApiLoading();
  useEffect(() => {
    setGlobalLoadingCallbacks(_showApiLoadingInternal, _hideApiLoadingInternal);
    return () => {
      setGlobalLoadingCallbacks(
        () => {},
        () => {}
      );
    };
  }, [_showApiLoadingInternal, _hideApiLoadingInternal]);

  return (
    <Router>
      <div className="font-sans flex flex-col min-h-screen">
        <Navbar />
        <main className="bg-white flex-grow pt-20 bg-gray-100">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about-us" element={<AboutUsPage />} />
            <Route path="/our-products" element={<OurProductsPage />} />
            <Route
              path="/products/:productName"
              element={<ProductDetailPage />}
            />
            <Route path="/infra" element={<InfraDetailPage />} />
            <Route path="/download" element={<DownloadsPage />} />
            <Route
              path="/case-study/:caseStudyName"
              element={<CaseStudyDetailPage />}
            />
            <Route path="/contact-us" element={<ContactUsPage />} />
          </Routes>
        </main>
        {isLoadingSharedData ? (
          <div className="bg-black text-white text-center p-6 mt-auto">
            Loading footer...
          </div>
        ) : (
          <Footer copyrightText={footerText} />
        )}
        <LoadingBackdrop isLoading={isApiLoading} />
      </div>
    </Router>
  );
}

export default App;
